import { LocationRow } from './LocationRow';
import styles from './LocationDropdown.module.css';

export const Dropdown = (props) => {
  const {
    className = '',
    items = [],
    loading,
    onSelect,
    value,
    theme = '',
    isAbsolute = false,
    rowComponent = LocationRow,
  } = props;
  return (
    <div
      className={`${styles.dropdown} ${
        theme ? styles[`dropdown_${theme}`] : ''
      } ${className}`}
    >
      <ul
        className={`${styles.dropdown__list} ${isAbsolute ? '' : 'h-[350px]'}`}
      >
        {!loading &&
          items.map((item) => {
            const isActive = item.value === value;
            const handleSelect = () => onSelect(item);
            const Comp = rowComponent;
            return (
              <Comp
                key={item.value}
                item={item}
                isActive={isActive}
                onSelect={handleSelect}
              />
            );
          })}
      </ul>
    </div>
  );
};
